import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtMaterialIcon from "./NtMaterialIcon";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtModalGroupItemsAddButton({
  containerStyle,
  title = "Add new phone",
  onPress,
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <NtTouchableEffect
      style={[styles.container, containerStyle]}
      onPress={onPress}
    >
      <NtMaterialIcon name="plus-circle" color={theme.brand2} size={16} />
      <NtText style={[styles.text, { marginLeft: 4 }]}>{title}</NtText>
    </NtTouchableEffect>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: { flexDirection: "row", alignItems: "center" },
    text: {
      fontSize: 12,
      fontWeight: "600",
      color: t.brand2,
    },
  });

export default NtModalGroupItemsAddButton;
